import { render, staticRenderFns } from "./NewsFocus.vue?vue&type=template&id=e9b3a4c0&scoped=true"
import script from "./NewsFocus.vue?vue&type=script&lang=js"
export * from "./NewsFocus.vue?vue&type=script&lang=js"
import style0 from "./NewsFocus.vue?vue&type=style&index=0&id=e9b3a4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b3a4c0",
  null
  
)

export default component.exports